module.exports = __webpack_public_path__ + "img/visual-04.cd4b1694.png";